/**
 * notificationNav.js — saf (React/router bağımsız, test edilebilir) bildirim
 * aktivasyon navigasyon kararı.
 *
 * BULGU (proje-yoneticisi/reviewer, Playwright ile doğrulandı): backend
 * announcement bildirimlerine admin özel bir link GİRMEDİYSE bile HER ZAMAN
 * bir `deeplink` yazıyor — fallback `/announcements/{ann_id}` (bkz.
 * backend/routes/notifications.py:320). Bu route web'de HİÇ YOK (ne admin
 * dışı bir duyuru listesi/detay sayfası var, ne de public bir GET
 * /announcements/{id} endpoint'i) — App.js'in catch-all'ı (`path="*"`) bunu
 * "/" landing'e düşürüyordu.
 *
 * ASIL FİX — App.js'e `/announcements/:id` route'u eklendi (şimdilik
 * `/bildirimler`'e redirect ediyor). Landing'e düşme regresyonunu ÇÖZEN
 * BUDUR.
 *
 * DÜZELTME (reviewer bulgusu 2026-07-23 — ikinci tur): bu modülün ilk
 * versiyonunun yorumu YANLIŞTI. `has_cta` alanının backend'de admin'in
 * GERÇEKTEN bir link girip girmediğini yansıttığı iddia ediliyordu, ama
 * `_serialize_user_notification` (backend/routes/notifications.py:72) şunu
 * yapıyor: `has_cta = bool(doc.get("has_cta", False)) or bool(doc.get("deeplink"))`.
 * announcement yolunda `deeplink` alanı HER ZAMAN dolu (admin link girmese
 * bile fallback `/announcements/{id}` yazılıyor) — bu yüzden API, stored
 * `has_cta` değeri ne olursa olsun, deeplink'i olan HER bildirim için
 * `has_cta=true` DÖNDÜRÜYOR. Yani `has_cta`, bu OR mantığı yüzünden mevcut
 * tüm yazım yolları için `deeplink` doluluğuyla FONKSİYONEL OLARAK AYNI şeyi
 * ifade ediyor — aşağıdaki `resolveNavigationTarget`'ın `has_cta` kontrolü,
 * bugünkü backend sözleşmesiyle deeplink kontrolünden FARKLI HİÇBİR ŞEYİ
 * FİLTRELEMİYOR (linksiz bir duyuru bile API'den has_cta=true olarak gelir).
 *
 * Yine de bu kontrol KALDIRILMADI (zararsız savunma katmanı) — backend
 * serializer'ındaki OR mantığı ileride `has_cta`'yı `deeplink`'ten bağımsız
 * doğru dolduracak şekilde değiştirilirse (ayrı bir backend kararı, bu turun
 * kapsamı dışında — bkz. proje raporu), bu fonksiyon herhangi bir frontend
 * değişikliği gerekmeden doğru filtrelemeye başlar.
 */

/**
 * Bildirim aktivasyonunda (satıra tıklama) navigate edilecek path'i döner.
 * Navigate edilmemesi gerekiyorsa null döner.
 *
 * @param {{ has_cta?: boolean, deeplink?: string|null }} notif
 * @returns {string|null}
 */
export function resolveNavigationTarget(notif) {
  if (!notif) return null;
  if (!notif.has_cta) return null;
  if (!notif.deeplink) return null;
  return notif.deeplink;
}
